import { LatitudeLongitude } from '@aloft/toolkit-shared';
import { bbox, featureCollection, point } from '@turf/turf';

import { LngLatBoundsLike, Map } from 'mapbox-gl';

export const fitBounds = (map: Map, comps: Partial<LatitudeLongitude>[]) => {
  const validPoints = comps.reduce((acc: ReturnType<typeof point>[], comp) => {
    if (!Number.isFinite(comp.latitude) || !Number.isFinite(comp.longitude)) return acc;

    return [...acc, point([comp.longitude as number, comp.latitude as number])];
  }, []);

  if (validPoints.length === 0) return;

  const bounds = bbox(featureCollection(validPoints)) as LngLatBoundsLike;

  map.fitBounds(bounds, { padding: 80 });
};
